import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import { Modal } from "@/Common/Components/Modals/Modal";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";

function PatientMergeRequestErrorPopup({ onClose, errorMessageKey }: Readonly<{ onClose: () => void, errorMessageKey: string }>): JSX.Element {
    const { getText } = useTranslation();

    return (
        <Modal
            title={getText("PatientMergeRequestPopup_ErrorTitle")}
            showX
            showOverlay
            onClose={onClose}
            footer={(
                <div className="flex-display flex-end">
                    <ButtonControl
                        variant="brand"
                        label={getText("OKLabel")}
                        onClick={onClose}
                    />
                </div>
            )}
        >
            <p>{getText(errorMessageKey)}</p>
        </Modal>
    );
}

export { PatientMergeRequestErrorPopup };
